import { render, staticRenderFns } from "./BaseTabControlContent.vue?vue&type=template&id=c530fa58&scoped=true&"
import script from "./BaseTabControlContent.vue?vue&type=script&lang=js&"
export * from "./BaseTabControlContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c530fa58",
  null
  
)

export default component.exports